import Icon from '../components/Icon.vue'

Icon.register({"ruler-horizontal":{"width":576,"height":512,"paths":[{"d":"M544 128H496V216C496 220.4 492.4 224 488 224H472C467.6 224 464 220.4 464 216V128H400V216C400 220.4 396.4 224 392 224H376C371.6 224 368 220.4 368 216V128H304V216C304 220.4 300.4 224 296 224H280C275.6 224 272 220.4 272 216V128H208V216C208 220.4 204.4 224 200 224H184C179.6 224 176 220.4 176 216V128H112V216C112 220.4 108.4 224 104 224H88C83.6 224 80 220.4 80 216V128H32C14.3 128 0 142.3 0 160V352C0 369.7 14.3 384 32 384H544C561.7 384 576 369.7 576 352V160C576 142.3 561.7 128 544 128z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ruler-horizontal.js
// module id = Cazo
// module chunks = 0